
    import './styles.scoped.css';
    export default {
  "content-enter": "awsui_content-enter_ig8mp_x0m7j_13",
  "awsui-motion-fade-in": "awsui_awsui-motion-fade-in_ig8mp_x0m7j_1",
  "tutorial-list": "awsui_tutorial-list_ig8mp_x0m7j_35",
  "tutorial-box": "awsui_tutorial-box_ig8mp_x0m7j_71",
  "tutorial-box-title": "awsui_tutorial-box-title_ig8mp_x0m7j_115",
  "tutorial-description-plaintext": "awsui_tutorial-description-plaintext_ig8mp_x0m7j_121",
  "tutorial-description": "awsui_tutorial-description_ig8mp_x0m7j_121",
  "expandable-section": "awsui_expandable-section_ig8mp_x0m7j_132",
  "expanded": "awsui_expanded_ig8mp_x0m7j_136",
  "button-wrapper": "awsui_button-wrapper_ig8mp_x0m7j_140",
  "start": "awsui_start_ig8mp_x0m7j_145",
  "expand-button": "awsui_expand-button_ig8mp_x0m7j_149",
  "collapse-button": "awsui_collapse-button_ig8mp_x0m7j_153",
  "learn-more-link": "awsui_learn-more-link_ig8mp_x0m7j_157",
  "title": "awsui_title_ig8mp_x0m7j_161",
  "prerequisites-alert": "awsui_prerequisites-alert_ig8mp_x0m7j_165",
  "completed": "awsui_completed_ig8mp_x0m7j_169",
  "download-link": "awsui_download-link_ig8mp_x0m7j_173"
};
  